module.exports = __webpack_public_path__ + "static/media/br-vk.3ddd1c03.gif";